import React from 'react';
import { DropdownIndicatorProps } from 'react-select';
import classNames from 'classnames';
import styles from '../../../DropdownIndicator/styles.module.scss';
import { SelectOption } from '../../..';
import { DropdownIcon } from '../../../../DropdownIcon';

export function DefaultDropdownIndicator(
  props: DropdownIndicatorProps<SelectOption, false>,
) {
  const className = props.className ?? 'fs-6';
  return (
    <DropdownIcon
      menuIsOpen={props.selectProps.menuIsOpen}
      classNames={classNames(
        props.isFocused ? styles['dropdown-focused'] : styles['dropdown'],
        className,
      )}
      isDisabled={props.isDisabled}
    />
  );
}
